import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=29cbc59d"
import script from "./safety.vue?vue&type=script&lang=js"
export * from "./safety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports